// extracted by mini-css-extract-plugin
export default {"container":"DesktopNavigation-module__container-gz3TeJ","isUpScrolled":"DesktopNavigation-module__isUpScrolled-jr8J3o","noSubItems":"DesktopNavigation-module__noSubItems-lb3p9Y"};